import { BaseService } from "./core/base-service";

export interface PropertyAuditEvent {
  _id: string;
  propertyId: string;
  userId: string;
  userRole?: string;
  timestamp: string;
  action: string;
  category: string;
  fieldPath?: string;
  oldValue?: any;
  newValue?: any;
  metadata?: any;
}

export interface PropertyAuditHistory {
  data: PropertyAuditEvent[];
  total: number;
  page: number;
  limit: number;
}

class PropertyAuditService extends BaseService {
  constructor() {
    super({ name: "property-audit", baseURL: process.env.NEXT_PUBLIC_API_URL });
  }

  async getHistory(propertyId: string, params?: Record<string, any>) {
    const res = await this.client.get<PropertyAuditHistory>(
      `/properties/${propertyId}/audit/history`,
      { params },
    );
    return res.data;
  }
}

export const propertyAuditService = new PropertyAuditService();
